import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 549F8173-7E91-411F-9ECF-D04D2B64B386
 * name angular
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/angular.svg
 * tags
 * - Brand / Logo 
 * - Developer / Languages 
 */
export const AngularIcon = createSvgIcon(<><path d="M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.6L6.47,17H8.53L9.64,14.22H14.34L15.45,17H17.5L12,4.6M13.62,12.5H10.39L12,8.63L13.62,12.5Z" /></>, 'AngularIcon');
export default AngularIcon